export default __webpack_public_path__ + "static/media/K2D-BoldItalic.9cd7c12c.ttf";